/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react'
import Recaptcha from 'react-recaptcha'

class RecaptchaTokenValut {
  constructor() {
    this.instance = null
    this.instanceResolver = null

    this.tokenInstance = null
    this.tokenPromise = null
    this.tokenResolver = null
    this.tokenRejecter = null
  }

  setInstance = (recaptchaInstance) => {
    this.instance = recaptchaInstance
    if (this.instanceResolver) {
      this.instanceResolver()
    }
  }

  getToken = (retry = 5) => {
    if (!this.instance) {
      return new Promise((resolve, _) => {
        this.instanceResolver = resolve
      }).then(() => {
        if (retry > 0) {
          console.error('retry recaptcha getToken times:', retry)
          setTimeout(() => this.getToken(retry - 1), 500)
        } else {
          console.error('recaptcha is not loaded')
          throw new Error('Recaptcha is not loaded')
        }
      })
    }
    if (this.tokenInstance) {
      return Promise.resolve(this.tokenInstance)
    }
    if (this.tokenPromise) {
      return this.tokenPromise
    }
    this.tokenPromise = new Promise((resolve, reject) => {
      this.tokenResolver = resolve
      this.tokenRejecter = reject
      this.instance.execute()
    })
    return this.tokenPromise
  }

  setToken = (token) => {
    if (this.tokenResolver) {
      this.tokenResolver(token)
    }
    this.tokenInstance = token
  }

  clearToken = () => {
    if (this.tokenRejecter) {
      this.tokenRejecter(new Error('Token expired'))
    }
    this.tokenInstance = null
    this.tokenPromise = null
    this.tokenResolver = null
    this.tokenRejecter = null
  }

  reset = () => {
    this.tokenInstance = null
    this.tokenPromise = null
    this.tokenResolver = null
    this.tokenRejecter = null

    if (this.instance) {
      this.instance.reset()
    }
  }

  hasInstance = () => {
    return !!this.instance
  }
}

export const recaptchaTokenValut = new RecaptchaTokenValut()

export class ReCAPTCHAWrapper extends Component {
  constructor(props) {
    super(props)
    this.innerRef = null
  }

  verifyCallback = (token) => {
    recaptchaTokenValut.setToken(token)
  }

  expiredCallback = () => {
    recaptchaTokenValut.clearToken()
  }

  onLoadRecaptcha = () => {
    recaptchaTokenValut.setInstance(this.innerRef)
  }

  setRef = (element) => {
    this.innerRef = element
  }

  render() {
    const { sitekey } = this.props
    return (
      <div style={{ visibility: 'hidden' }}>
        <Recaptcha
          ref={this.setRef}
          size="invisible"
          render="explicit"
          sitekey={sitekey}
          verifyCallback={this.verifyCallback}
          onloadCallback={this.onLoadRecaptcha}
          expiredCallback={this.expiredCallback}
        />
      </div>
    )
  }
}
